import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

/**
 * Componente para proteger rutas que requieren autenticaciu00f3n
 */
const PrivateRoute: React.FC = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  // Si no estu00e1 autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si estu00e1 autenticado, renderizar el contenido anidado
  return <Outlet />;
};

export default PrivateRoute; 